module.exports = __webpack_public_path__ + "static/media/Dev_binary.9f96eaba.png";